/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesTenantBillingDtosTenantInvoiceDto
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getMeTenantInvoices = () => {
const getApiV1MeTenantBillingInvoices = (
    
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTenantBillingDtosTenantInvoiceDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesTenantBillingDtosTenantInvoiceDto[]>(
      {url: `/api/v1/me/tenant-billing/invoices`, method: 'GET'
    },
      options);
    }
  const getApiV1MeTenantBillingInvoicesId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTenantBillingDtosTenantInvoiceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesTenantBillingDtosTenantInvoiceDto>(
      {url: `/api/v1/me/tenant-billing/invoices/${id}`, method: 'GET'
    },
      options);
    }
  const getApiV1MeTenantBillingInvoicesIdPdf = (
    id: string,
 options?: SecondParameter<typeof customInstance<Blob>>,) => {
      return customInstance<Blob>(
      {url: `/api/v1/me/tenant-billing/invoices/${id}/pdf`, method: 'GET',
        responseType: 'blob'
    },
      options);
    }
  return {getApiV1MeTenantBillingInvoices,getApiV1MeTenantBillingInvoicesId,getApiV1MeTenantBillingInvoicesIdPdf}};
export type GetApiV1MeTenantBillingInvoicesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeTenantInvoices>['getApiV1MeTenantBillingInvoices']>>>
export type GetApiV1MeTenantBillingInvoicesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeTenantInvoices>['getApiV1MeTenantBillingInvoicesId']>>>
export type GetApiV1MeTenantBillingInvoicesIdPdfResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeTenantInvoices>['getApiV1MeTenantBillingInvoicesIdPdf']>>>
